import { apiRequest } from "../api";

export const getOrders = (query: string) => apiRequest(`/orders?${query}`, "GET");
export const getOrder = (id: string) => apiRequest(`/orders/${id}`, "GET");
export const updateOrder = (id: string, payload: unknown) =>
  apiRequest(`/orders/${id}`, "PUT", payload);
export const updateOrderAction = (id: string, action: string, payload: unknown) =>
  apiRequest(`/orders/${id}/${action}`, "PUT", payload);
export const deleteOrder = (id: string) => apiRequest(`/orders/${id}`, "DELETE");
